import React from "react";
import {
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from "@material-ui/core";
import classNames from "classnames";
import { EventStatus } from "@prestosports/prestostats-core/Common";
import { useTeamsContext } from "../../../state/teams/context";
import Team from "../../team/components/Team";
import lineScoreStyles from "../styles/LineScore.styles";
import { useEventContext } from "../../../state/events/context";
import boxScoreStyles from "../styles/BoxScore.styles";

const teamRow = (team, scores, isFinal) => {
	const classes = lineScoreStyles();
	const boxScoreClasses = boxScoreStyles();

	return (
		<TableRow className={classes.row} key={team.id}>
			<TableCell>
				<Team team={team} />
			</TableCell>
			{scores.map((s) => (
				<TableCell
					align="center"
					className={classNames({
						[boxScoreClasses.inProgress]: s.isTotal && !isFinal,
						[boxScoreClasses.final]: s.isTotal && isFinal
					})}
					key={`${team.id}-${s.number}`}
				>
					{s.score}
				</TableCell>
			))}
		</TableRow>
	);
};

const LineScore = ({ boxScore = {} }) => {
	const classes = lineScoreStyles();
	const boxScoreClasses = boxScoreStyles();

	const { state: teamState } = useTeamsContext();
	const homeTeam = teamState.homeTeam();
	const awayTeam = teamState.awayTeam();

	const { state: eventState } = useEventContext();
	const isFinal = EventStatus.isFinal(eventState.currentEvent());

	const { lineScore } = boxScore;

	return (
		<Paper variant="outlined">
			<TableContainer>
				<Table aria-label="linescore" size="small">
					<TableHead>
						<TableRow className={classes.header}>
							<TableCell>Result</TableCell>
							{lineScore.map((lineScoreItem) => (
								<TableCell
									align="center"
									className={classNames(classes.period, {
										[boxScoreClasses.inProgress]: lineScoreItem.isTotal && !isFinal,
										[boxScoreClasses.final]: lineScoreItem.isTotal && isFinal
									})}
									key={lineScoreItem.number}
								>
									{lineScoreItem.number}
								</TableCell>
							))}
						</TableRow>
					</TableHead>
					<TableBody>
						{teamRow(
							awayTeam,
							lineScore.map((p) => {
								return { score: p.awayScore, isTotal: p.isTotal, number: p.number };
							}),
							isFinal
						)}
						{teamRow(
							homeTeam,
							lineScore.map((p) => {
								return { score: p.homeScore, isTotal: p.isTotal, number: p.number };
							}),
							isFinal
						)}
					</TableBody>
				</Table>
			</TableContainer>
		</Paper>
	);
};

export default LineScore;
